import React from 'react';
import { Box, Text } from 'grommet';
import SHDText from '@ui/Text/SHDText';

interface SubscriptionTermOptionProps {
  id: string;
  label: string;
  price: string;
  suffix: string;
  tag?: string;
  isActive: boolean;
  onSelected: () => void;
}

const SubscriptionTermOption: React.FC<SubscriptionTermOptionProps> = ({
  label,
  price,
  suffix,
  tag,
  isActive,
  onSelected,
}) => {
  return (
    <Box
      onClick={onSelected}
      role="button"
      round="16px"
      pad="xsmall"
      border={{
        color: isActive ? 'green' : 'gray-300',
        size: '1px',
      }}
      style={{
        position: 'relative',
        cursor: 'pointer',
        height: '94px',
        width: '100%',
        transition: 'border 0.2s ease-in-out',
      }}
    >
      <Box
        style={{ position: 'absolute', bottom: '0.75rem', left: '1.0625rem' }}
      >
        <SHDText style="body" color="gray-700">
          {label}
        </SHDText>
        <Box direction="row" align="baseline">
          <SHDText style="subhead-semibold" color="black">
            {price}
            <span
              style={{ fontWeight: 400, fontSize: '14px', marginLeft: '2px' }}
            >
              /{suffix}
            </span>
          </SHDText>
        </Box>
      </Box>

      {tag && (
        <Box
          style={{
            position: 'absolute',
            top: '0.625rem',
            right: '0.625rem',
            backgroundColor: 'rgba(51, 153, 25, 0.1)',
            borderRadius: '7px',
            padding: '2px 8px',
            height: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Text
            style={{
              color: '#1C8700',
              fontFamily: 'Messina Sans',
              fontSize: '10px',
              fontStyle: 'normal',
              fontWeight: 600,
              lineHeight: '20px',
            }}
          >
            {tag}
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default SubscriptionTermOption;
